/**
 * Qué versión del frontend corre en esta pestaña, y cuál está publicada.
 *
 * CRA nombra el bundle principal `static/js/main.<hash>.js` y ese hash cambia con cada
 * build. El `index.html` publicado (que CloudFront y nginx sirven SIN caché) lo referencia,
 * así que comparar el hash del `<script>` que ejecuta el navegador con el del `index.html`
 * que hay ahora en el servidor dice si hay un despliegue posterior a esta pestaña.
 *
 * Funciones puras, sin React ni red: el hook `useVersionNueva` las usa, y aquí se prueban
 * en cinco líneas sin timers ni fetch. Nacen del 09-10-2026 (ver el hook).
 */

// También casa con un prefijo absoluto (`https://cdn…/static/js/main.x.js`): si algún día el
// bundle sale de un CDN propio, esto no se rompe.
const MAIN_HASHEADO = /\/static\/js\/main\.([0-9a-f]+)\.js/;

/** Hash del bundle que ejecuta esta pestaña, o `null` si no hay bundle hasheado (`npm start`). */
export function hashDelBundleEnEjecucion(doc = document) {
  const script = doc.querySelector('script[src*="/static/js/main."]');
  return hashDelBundleEnHtml(script ? script.getAttribute("src") || "" : "");
}

/** Hash del bundle que referencia un `index.html` (o cualquier texto), o `null` si no lo hay. */
export function hashDelBundleEnHtml(html) {
  const m = typeof html === "string" ? html.match(MAIN_HASHEADO) : null;
  return m ? m[1] : null;
}
